<template>
<div class="chapter">
<div class="inner_page">
<p class="block_15" id="calibre_pb_4"> </p>
<p class="block_14"> </p>
<p class="block_14"> </p>
<p class="block_14"> </p>
<p class="block_14"> </p>
<p class="block_14"> </p>
<p class="block_14"> </p>
<p class="block_16"> </p>
<p class="block_16"> </p>
<p class="block_17"><span class="text_3">Hope Rowana’s life was the mad production of a twisted director.</span></p>
<p class="block_6"><span class="text_3"><br class="calibre1" id="calibre_pb_5"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?8de6354c